import {GoalType} from "@/ts/Goal/Type/Goal";
import {useYandexMetrika} from 'yandex-metrika-vue3'
import AuthService from "@/ts/User/Service/AuthService";
import {EmptyYaMetrika} from "yandex-metrika-vue3/src/empty-ya";

const yandexMetrika = useYandexMetrika()
export default class Metrika {

    private static async isLoaded(): Promise<void> {
        return new Promise((resolve) => {
            const checkMetrika = setInterval(() => {
                if (!(yandexMetrika.metrika instanceof EmptyYaMetrika)) {
                    clearInterval(checkMetrika);
                    resolve();
                }
            }, 100);
        });
    }
    public static async authUser(): Promise<void> {
        try {
            await this.isLoaded()
            const userId = await AuthService.getUserId()
            yandexMetrika.setUserID(userId)
            yandexMetrika.userParams({
                email: await AuthService.getUserEmail(),
                UserID: userId
            })
        } catch (e) {
        }
    }

    public static userRegistered(email: string): void {
        const params = {
            email
        }
        // @ts-ignore
        yandexMetrika.reachGoal('user-registered', params)
    }

    public static paySubscription(email: string): void {
        const params = {
            email
        }
        // @ts-ignore
        yandexMetrika.reachGoal('pay-subscription', params)
    }

    public static goalCreated(type: GoalType, id: string): void {
        const params = {
            goalId: id
        }
        // @ts-ignore
        yandexMetrika.reachGoal(type + 'goal-created', params)
        console.log(`Goal ${type} created`);
    }

    public static meditationListened(): void {
        console.log(`Meditation listened`);
    }

    public static musicListened(): void {
        console.log(`Music listened`);
    }

    public static bookListViewed(): void {
        console.log(`Book list viewed`);
    }

    public static bookViewed(): void {
        console.log(`Book viewed`);
    }

    public static bookPartRead(): void {
        console.log(`Book part read`);
    }

    public static cardListViewed(): void {
        console.log(`Card list viewed`);
    }

    public static cardViewed(): void {
        console.log(`Card viewed`);
    }

    public static cardPlayed(): void {
        console.log(`Card played`);
    }

    public static videoViewed(): void {
        console.log(`Video viewed`);
    }

    public static bigMoneyTrainingViewed(): void {
        console.log(`Big money training viewed`);
    }

    public static chatTyped(): void {
        console.log(`Chat typed`);
    }

    public static desireDone(): void {
        console.log(`Desire done`);
    }

    public static desireCreated(): void {
        console.log(`Desire created`);
    }

    public static travelCreated(): void {
        console.log(`Travel created`);
    }
}
